import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

export const StyledSmartChoiceChipText = styled(Text, {
  '&.abyss-text-root': {
    color: '#4B4D4F',
    backgroundColor: '#F3F3F3',
    padding: '2px',
    paddingLeft: '6px',
    paddingRight: '6px',
    marginRight: '4px',
    borderRadius: '4px',
    fontWeight: 700,
    fontSize: '$sm',
  },
});

export const StyledSmartChoiceChipContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'row',
});

export const StyledSmartChoiceWrapper = styled('div', {
  paddingBottom: '8px',
});

export const StyledPopoverWrapper = styled('div', {});
